import { useEffect } from "react";

import { usePromiseStatus } from "../../../Lib/UI/Hooks/usePromiseStatus";
import { useAction } from "../../../Lib/Actions/useAction";
import { ISettingsService } from "../../../Settings/serviceTypes";
import { ITileCache, ITileCacheInfo } from "../../MapComponents/TileCache/types";


export interface SettingsListProps {
    service: ISettingsService;
    tileCache: ITileCache;
    map: L.Map;
}

export const useSettingsList = (props: SettingsListProps) => {

    const settings = props.service.settings;

    const confirmClearTileCacheAction = useAction<void, boolean>();

    const currentCacheInfoStatus = usePromiseStatus<ITileCacheInfo>();
    const cacheInfo = currentCacheInfoStatus.result;

    const getCacheInfo = () => {
        const getCacheInfoPromise = props.tileCache.getInfo();
        currentCacheInfoStatus.setPromise(getCacheInfoPromise); 
    };

    useEffect(() => {
        getCacheInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getClearTileCachePromise = () => {
        return props.tileCache.purgeStore().then(getCacheInfo);
    };

    return {
        settings,
        cacheInfo, currentCacheInfoStatus,
        confirmClearTileCacheAction,
        getClearTileCachePromise
    };

};